window.addEventListener('scroll', function () {
  const header = document.querySelector('.js-header');

  if (!header) return;

  if (window.scrollY > 10) {
    header.classList.add('active');
  } else {
    header.classList.remove('active');
  }
});

document.querySelectorAll('.js-open-megamenu').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const index = button.getAttribute('data-index');
    const megamenu = document.querySelector(`.js-megamenu[data-index="${index}"]`);
    if (megamenu) {
      megamenu.classList.add('display');
      setTimeout(() => {
        megamenu.classList.add('show');
      }, 50);
      if (window.lenis) {
        window.lenis.stop();
      } else {
        document.body.style.overflow = 'hidden';
      }
    }
  });
});

document.querySelectorAll('.js-close-megamenu').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const megamenu = button.closest('.js-megamenu');
    if (megamenu) {
      megamenu.classList.add('closing');
      setTimeout(() => {
        megamenu.classList.remove('display', 'show', 'closing');
        if (window.lenis) {
          window.lenis.start();
        } else {
          document.body.style.overflow = 'visible';
        }
      }, 300);
    }
  });
});

document.querySelectorAll('.js-open-mobile-megamenu').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();

    const megamenu = button.parentElement.querySelector('.js-mobile-megamenu');
    if (!megamenu) return;

    const isOpen = megamenu.classList.contains('is-open');

    megamenu.style.overflow = 'hidden';
    megamenu.style.transition = 'height 0.3s ease';

    if (!isOpen) {
      megamenu.classList.add('is-open');
      button.classList.add('active');

      megamenu.style.height = '0px';

      void megamenu.offsetHeight;

      megamenu.style.height = megamenu.scrollHeight + 'px';

      megamenu.addEventListener('transitionend', function handler() {
        megamenu.style.height = 'auto';
        megamenu.removeEventListener('transitionend', handler);
      });

    } else {
      megamenu.style.height = megamenu.scrollHeight + 'px';

      void megamenu.offsetHeight;

      megamenu.style.height = '0px';
      button.classList.remove('active');

      megamenu.addEventListener('transitionend', function handler() {
        megamenu.classList.remove('is-open');
        megamenu.style.height = '';
        megamenu.removeEventListener('transitionend', handler);
      });
    }
  });
});

document.querySelectorAll('.js-open-mobile-menu').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const mobilemenu = document.querySelector(`.js-mobile-menu`);
    if (mobilemenu) {
      mobilemenu.classList.add('display');
      setTimeout(() => {
        mobilemenu.classList.add('show');
      }, 50);
      if (window.lenis) {
        window.lenis.stop();
      } else {
        document.body.style.overflow = 'hidden';
      }
    }
  });
});

document.querySelectorAll('.js-close-mobile-menu').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const mobilemenu = button.closest('.js-mobile-menu');
    if (mobilemenu) {
      mobilemenu.classList.add('closing');
      setTimeout(() => {
        mobilemenu.classList.remove('display', 'show', 'closing');
        if (window.lenis) {
          window.lenis.start();
        } else {
          document.body.style.overflow = 'visible';
        }
      }, 300);
    }
  });
});